import React from 'react';
import exact from 'prop-types-exact';


import PageLayout from '../../layouts/PageLayout';
import SplitLayout from '../../layouts/SplitLayout';


import InvoiceInbox from './containers/InvoiceInbox';
import InvoiceReview from './containers/InvoiceReview';


import './containers/style.css';


const propTypes = exact({});


const TicketInvoicingPage = (props) => {
  return (
    <PageLayout
      title="Ticket Invoicing"
      render={() => {
        return (
          <SplitLayout
            leftSize={3}
            leftRender={() => { return <InvoiceInbox />; }}
            rightSize={9}
            rightRender={() => { return <InvoiceReview />; }}
          />
        );
      }}
    />
  );
};


TicketInvoicingPage.propTypes = propTypes;


export default TicketInvoicingPage;
